import React, { useEffect, useState } from 'react';
import useFormInstance from 'antd/es/form/hooks/useFormInstance';
import { usePortSelectGet } from '../../../../../../hooks/api/order';
import OrderSelect, { OrderSelectProps } from '../Select';

function SelectPort({
  fetch,
  selectProps = {},
  rest = {},
  ...props
}: OrderSelectProps) {
  const portSelectGet = usePortSelectGet();

  const form = useFormInstance();

  const [search, setSearch] = useState<string | undefined>();

  const fetchFunc = (val: string) => {
    portSelectGet.fetch({ search: val || undefined });
  };

  useEffect(() => {
    if (form) {
      fetchFunc(form.getFieldValue(props.name) || undefined);
    }
  }, []);

  useEffect(() => {
    if (search || search === '') {
      const timeoutId = setTimeout(() => fetchFunc(search), 500);

      return () => clearTimeout(timeoutId);
    }

    return undefined;
  }, [search]);

  return (
    <OrderSelect
      fetch={portSelectGet}
      selectProps={{
        ...selectProps,
        loading: portSelectGet.loading,
        searchValue: search,
        onSearch: setSearch,
      }}
      rest={rest}
      {...props}
    />
  );
}

export default SelectPort;
